import { render, staticRenderFns } from "./reviewCard.vue?vue&type=template&id=68e933d4&scoped=true"
import script from "./reviewCard.vue?vue&type=script&lang=js"
export * from "./reviewCard.vue?vue&type=script&lang=js"
import style0 from "./reviewCard.vue?vue&type=style&index=0&id=68e933d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e933d4",
  null
  
)

export default component.exports